"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _flags = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/flags"));
var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));
var _ContainerHeader = _interopRequireDefault(require("./ContainerHeader"));
var _Sidebar = _interopRequireDefault(require("./Sidebar"));
var _NotConnected = _interopRequireDefault(require("./NotConnected"));
var _MessageList = _interopRequireDefault(require("./MessageList"));
var _ServerView = _interopRequireDefault(require("./ServerView"));
var _default = exports.default = {
  components: {
    ContainerHeader: _ContainerHeader.default,
    Sidebar: _Sidebar.default,
    NotConnected: _NotConnected.default,
    MessageList: _MessageList.default,
    ServerView: _ServerView.default
  },
  props: ['network', 'buffer', 'sidebarState'],
  data: function data() {
    return {
      canScrollLeft: false,
      canScrollRight: false,
      confirmCloseBufferData: null
    };
  },
  computed: {
    bufferType: function bufferType() {
      var type = '';
      if (!this.buffer) {
        type = 'none';
      } else if (this.buffer.isServer()) {
        type = 'server';
      } else if (this.buffer.isChannel()) {
        type = 'channel';
      } else if (this.buffer.isQuery()) {
        type = 'query';
      }
      return type;
    },
    unreadMessages: function unreadMessages() {
      var count = 0;
      var highlight = false;
      this.$state.networks.forEach(function (network) {
        network.buffers.forEach(function (buffer) {
          count += (0, _flags.default)(buffer).unread || 0;
          if ((0, _flags.default)(buffer).highlight) {
            highlight = true;
          }
        });
      });
      return {
        count: count,
        highlight: highlight
      };
    },
    tabBuffers: function tabBuffers() {
      var _this = this;
      // Get all non-server buffers and sort: channels first, then queries
      // Use buffer name to determine type reliably (channels start with #, &, +, or !)
      var allBuffers = [];
      this.$state.networks.forEach(function (network) {
        network.buffers.forEach(function (buf) {
          // Skip server buffers entirely
          if (buf.isServer()) {
            return;
          }
          allBuffers.push(buf);
        });
      });

      // Sort: channels (name starts with # & + !) come before queries
      // If both are same type, maintain original order (stable sort)
      (0, _sort.default)(allBuffers).call(allBuffers, function (a, b) {
        var aIsChannel = _this.isChannelBuffer(a);
        var bIsChannel = _this.isChannelBuffer(b);
        if (aIsChannel && !bIsChannel) {
          return -1; // a (channel) comes before b (query)
        }
        if (!aIsChannel && bIsChannel) {
          return 1; // b (channel) comes before a (query)
        }
        return 0; // same type, keep original order
      });
      return allBuffers;
    },
    showBufferTabs: function showBufferTabs() {
      // Only show tabs when there are channels or PMs
      return this.tabBuffers.length > 0;
    }
  },
  watch: {
    tabBuffers: function tabBuffers() {
      var _this2 = this;
      this.$nextTick(function () {
        _this2.updateScrollArrows();
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;
    this.$nextTick(function () {
      _this3.updateScrollArrows();
    });
    if (this.$refs.bufferTabs) {
      this.$refs.bufferTabs.addEventListener('scroll', this.updateScrollArrows);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$refs.bufferTabs) {
      this.$refs.bufferTabs.removeEventListener('scroll', this.updateScrollArrows);
    }
  },
  created: function created() {
    var _this4 = this;
    this.listen(this.$state, 'sidebar.toggle', function () {
      _this4.$state.$emit('sidebar.' + (_this4.sidebarState.isDrawn ? 'hide' : 'show'));
    });
    this.listen(this.$state, 'sidebar.show', function () {
      _this4.sidebarState.showNicklist();
    });
    this.listen(this.$state, 'sidebar.hide', function () {
      _this4.sidebarState.close();
    });
    this.listen(this.$state, 'userbox.show', function (user, opts) {
      _this4.sidebarState.showUser(user);
    });
    this.listen(this.$state, 'userbox.hide', function () {
      _this4.sidebarState.close();
    });
    this.listen(this.$state, 'document.keydown', function (ev) {
      // Return if not Page Up or Page Down keys
      if (ev.key !== 'PageUp' && ev.key !== 'PageDown') {
        return;
      }

      // if no messagelist, select the first tabbed content to allow channel list scrolling
      var messageList = _this4.$el.querySelector('.kiwi-messagelist') || _this4.$el.querySelector('.u-tabbed-content');
      if (!messageList) {
        return;
      }

      // Fix for chrome issue breaking layout when page up/down is pressed while inside
      // contenteditible or inputbox
      // https://bugs.chromium.org/p/chromium/issues/detail?id=890248
      ev.preventDefault();
      var scrollDistance = messageList.clientHeight - 0.1 * messageList.clientHeight;
      var scrollTop = messageList.scrollTop;
      var scrollMax = messageList.scrollHeight;
      if (ev.key === 'PageUp') {
        // up
        scrollTop -= scrollDistance;
        if (scrollTop < 0) {
          scrollTop = 0;
        }
      } else {
        // down
        scrollTop += scrollDistance;
        if (scrollTop > scrollMax) {
          scrollTop = scrollMax;
        }
      }
      messageList.scrollTop = scrollTop;
    });
  },
  methods: {
    toggleStateBrowser: function toggleStateBrowser() {
      this.$state.$emit('statebrowser.toggle');
    },
    toggleSidebar: function toggleSidebar() {
      if (this.buffer.isChannel()) {
        this.$state.$emit('sidebar.toggle');
      }
    },
    isChannelBuffer: function isChannelBuffer(buf) {
      // Reliable check: channel names start with #, &, +, or !
      // This works even before isChannel() is fully initialized
      var firstChar = buf.name.charAt(0);
      return firstChar === '#' || firstChar === '&' || firstChar === '+' || firstChar === '!';
    },
    isQueryBuffer: function isQueryBuffer(buf) {
      // Query/PM if not a channel and not a server
      return !this.isChannelBuffer(buf) && !buf.isServer();
    },
    setActiveBuffer: function setActiveBuffer(tabBuffer) {
      // KiwiIRC's setActiveBuffer requires (networkid, bufferName)
      var bufferNetwork = tabBuffer.getNetwork();
      if (bufferNetwork) {
        this.$state.setActiveBuffer(bufferNetwork.id, tabBuffer.name);
      }
    },
    onCloseClick: function onCloseClick(tabBuffer, event) {
      // Prevent any parent click handlers from firing
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      // If it's a PM/query, close immediately without confirmation
      if (this.isQueryBuffer(tabBuffer)) {
        this.$state.removeBuffer(tabBuffer);
        return;
      }
      // If it's a channel, show confirmation modal
      this.confirmCloseBufferData = tabBuffer;
    },
    doCloseBuffer: function doCloseBuffer() {
      if (this.confirmCloseBufferData) {
        this.$state.removeBuffer(this.confirmCloseBufferData);
        this.confirmCloseBufferData = null;
      }
    },
    cancelCloseBuffer: function cancelCloseBuffer() {
      this.confirmCloseBufferData = null;
    },
    scrollTabs: function scrollTabs(direction) {
      var tabsEl = this.$refs.bufferTabs;
      if (!tabsEl) return;
      var scrollAmount = 200;
      if (direction === 'left') {
        tabsEl.scrollBy({
          left: -scrollAmount,
          behavior: 'smooth'
        });
      } else {
        tabsEl.scrollBy({
          left: scrollAmount,
          behavior: 'smooth'
        });
      }
    },
    updateScrollArrows: function updateScrollArrows() {
      var tabsEl = this.$refs.bufferTabs;
      if (!tabsEl) return;
      this.canScrollLeft = tabsEl.scrollLeft > 0;
      this.canScrollRight = tabsEl.scrollLeft < tabsEl.scrollWidth - tabsEl.clientWidth - 1;
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["Container"]
window._kiwi_exports.components.Container = exports.default ? exports.default : exports;
